import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import DetentionList from "../DetentionList";
import { BookingsSectionTitle } from "./styles";
import Modal from "@/common/elements/Modal";
import { useEffect, useState } from "react";
import AddDetention from "../AddDetention";
import {
  debounce,
  getOptionsFromRefList,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { setBookings } from "@/slices/bookingsSlice";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { MODULES_LIST_WITH_ID, SUB_MODULES_LIST_WITH_ID } from "@/util/common_variable";

const BookingInformationDetails = ({startingPoint}) => {
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const [form] = Form.useForm();
  const [showAddDetention, setShowAddDetention] = useState(false);
  const [bookingInfo, setBookingInfo] = useState(null);
  const clickAddDetention = () => {
    setShowAddDetention(true);
  };

  const currentUser = JSON.parse(localStorage.getItem("userDetails"))?.username;
  const fullSearch = useSelector(state => state.fullSearch);
  const userStaffID = JSON.parse(localStorage.getItem("userDetails"))?.staffId;

  useEffect(() => {
    if (bookings !== null) {
      const incarcerationDate = bookings?.arrestReports?.[0]?.incarcerationDate;
      const incarcerationTime = bookings?.arrestReports?.[0]?.incarcerationTime;
      setBookingInfo({
        bookingOfficerStaffId: isNonEmptyVariable(
          bookings?.arrestReports?.[0]?.bookingOfficerStaffId
        )
          ? bookings?.arrestReports?.[0]?.bookingOfficerStaffId
          : fullSearch ? null : currentUser,
        incarcerationDateTime:
          incarcerationDate && incarcerationTime
            ? dayjs(`${incarcerationDate} ${incarcerationTime}`)
            : fullSearch ? "" : dayjs(),
      });
    } else {
      setBookingInfo(null);
    }
  }, [bookings]);

  useEffect(() => {
    if (bookingInfo !== null) {
      form.setFieldsValue(bookingInfo);
    } else {
      form.resetFields();
    }
  }, [bookingInfo]);

  const updateForm = (data) => {
    dispatch(
      setBookings({
        arrestReports: [
          {
            ...bookings?.arrestReports?.[0],
            ...data,
          },
        ],
      })
    );
  };

  const dataModify = debounce(() => {
    const values = form.getFieldsValue();

    values.incarcerationDateTime = values?.incarcerationDateTime
      ? dayjs(values?.incarcerationDateTime)?.format("MM/DD/YYYY HH:mm")
      : null;

    const data = {
      ...values,
      incarcerationDate: values?.incarcerationDateTime?.split(" ")[0],
      incarcerationTime: values?.incarcerationDateTime?.split(" ")[1],
      bookingOfficerStaffId:
        values?.bookingOfficerStaffId === currentUser
          ? userStaffID
          : values?.bookingOfficerStaffId,
    };

    delete data?.incarcerationDateTime;

    updateForm(data);
  }, 600);

  return (
    <>
      {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report
        )&&<><Form
        form={form}
        disabled={!bookingsFieldsEnabled}
        initialValues={bookingInfo}
        onFieldsChange={() => {
          dataModify();
        }}
      >
        <StyledGridRow gutter={16}>
          <StyledGridCol span="6">
            <FormItem name="bookingOfficerStaffId" label="Booking Officer">
              <Select
                id="BI-BookingOfficer"
                options={getOptionsFromRefList("", true, false, true)}
                placeholder="Booking Officer"
                showSearch={false}
                variant="outlined"
                disabled={!bookingsFieldsEnabled ||!hasCheckSecurity(Security_Types.functionality,Entity_types.field,LABELS_CAPITAL.MODIFY,"","","ArrestReports","bookingOfficerStaffId",startingPoint)}
                className={hasCheckSecurity(Security_Types.functionality,Entity_types.field,LABELS_CAPITAL.VIEW,"","","ArrestReports","bookingOfficerStaffId",startingPoint)?"":"input-control-mask"}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span="6">
            <FormItem
              name="incarcerationDateTime"
              label="Incarceration Date And Time"
              required={!fullSearch}
              rules={
                !fullSearch
                ? [
                  {
                    required: true,
                    message:
                      "If the inmate is incarcerated,you must enter the incarceration date.",
                  },
                ] : []
              }
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                disabled={!bookingsFieldsEnabled ||!hasCheckSecurity(Security_Types.functionality,Entity_types.field,LABELS_CAPITAL.MODIFY,"","","ArrestReports","incarcerationDateTime",startingPoint)}
                disableFutureDates={true}
                className={hasCheckSecurity(Security_Types.functionality,Entity_types.field,LABELS_CAPITAL.VIEW,"","","ArrestReports","incarcerationDateTime",startingPoint)?"":"input-control-mask"}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>

      <BookingsSectionTitle style={{ marginBottom: "10px", marginTop: "15px" }}>
        <span>Detentions</span>
      </BookingsSectionTitle>

      {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report
        )&&<DetentionList switchToAddDetention={clickAddDetention} />}

      <Modal
        header={"Detention"}
        show={showAddDetention}
        designPattern="ant"
        width="75%"
        onHide={() => setShowAddDetention(false)}
        footerActions={[
          {
            key: "save",
            text: "Save",
            disabled: !bookingsFieldsEnabled,
          },
        ]}
        footerCloseAction
        footerCloseActionText="Close"
      >
        <AddDetention bookingsFieldsEnabled={bookingsFieldsEnabled} />
      </Modal></>}
    </>
  );
};

export default BookingInformationDetails;
